import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs, Dropdown, Menu } from 'antd';
import { withRouter } from 'react-router-dom';
import Translate from 'react-translate-component';

import { openModalWorksheetMassSettings } from 'actions/modalActions';
import RefreshButton from 'components/common/controls/RefreshButton';
import CustomIcon from 'components/common/CustomIcon';

@connect(null, { openModalWorksheetMassSettings })
@withRouter
export default class WorksheetMassListControls extends Component {
    static propTypes = {
        refreshMeta: PropTypes.object.isRequired,
        handleRefresh: PropTypes.func.isRequired,
        openModalWorksheetMassSettings: PropTypes.func.isRequired,
        filters: PropTypes.object.isRequired,
        handleFilters: PropTypes.func.isRequired,
        history: PropTypes.object,
        match: PropTypes.object,
        pagination: PropTypes.object,
        setPagination: PropTypes.func,
        stages: PropTypes.array,
    };

    static defaultProps = {
        stages: []
    };

    getDropdownStages = () => {
        const { stages, match: { params: { stage } } } = this.props;

        return <Menu selectedKeys={[stage]} className='mass-worksheet-stages-dropdown'>
            <Menu.Item className='text-right' disabled>
                <Translate content='worksheetMass.stages' component='span' />
            </Menu.Item>
            { stages.map(stage =>
                <Menu.Item key={stage.id} onClick={({ key }) => this.onChange(key)}>
                    { stage.name }
                </Menu.Item>
            )}
        </Menu>
    }

    extraContent = () => {
        const { refreshMeta, handleRefresh, openModalWorksheetMassSettings } = this.props;

        return <div className="icon-bar">
            <Dropdown trigger={['click']} placement='bottomRight' overlay={this.getDropdownStages()}>
                <a><CustomIcon type='filter' /></a>
            </Dropdown>
            <a onClick={() => openModalWorksheetMassSettings()}>
                <CustomIcon type="settings" />
            </a>
            <RefreshButton refreshMeta={refreshMeta} handleRefresh={handleRefresh} />
        </div>;
    }

    onChange = key => {
        const { history, match: { params: { id, stage } }, setPagination } = this.props;

        if (key !== stage) {
            history.push(`/project_mass/${id}/worksheet/${key}`);
            setPagination(1);
        }
    }

    render() {
        const { stages, match: { params: { stage } } } = this.props;

        return (
            <div className="ant-row">
                <Tabs
                    className='scroll-tabs'
                    activeKey={stage}
                    tabBarExtraContent={this.extraContent()}
                    onChange={this.onChange}
                >
                    { stages.map(stage =>
                        <Tabs.TabPane key={stage.id} tab={stage.name} />
                    )}
                </Tabs>
            </div>
        );
    }
}
